import { render } from "./About.vue?vue&type=template&id=17d6f708"
const script = {}
script.render = render

export default script